function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#222",
  d: "M19.2587038,13.9015458 C19.6288147,16.0462375 20.4436664,17.4277853 22,18.9999999 L2,18.9999999 C4.33333333,16.6428571 5,14.7142856 5,9.99999992 C5,4.62466417 7.87065007,3.30923625 10,2.99999992 C10,1.98306631 10.7589811,1.14340225 11.7413845,1.01656668 C10.6514389,2.38360459 10,4.1157264 10,5.99999992 C10,10.4182779 13.581722,13.9999999 18,13.9999999 C18.428261,13.9999999 18.8486622,13.9663485 19.2587038,13.9015458 Z M9.5,19.9999999 L15.5,19.9999999 C15.5,21.6568542 14.1568542,22.9999999 12.5,22.9999999 C10.8431458,22.9999999 9.5,21.6568542 9.5,19.9999999 Z"
}), React.createElement("circle", {
  cx: 18,
  cy: 6,
  r: 6,
  fill: "#A9DDA8"
}));

var SvgBellAlert = function SvgBellAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBellAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BellAlert.89378324.svg";
export { ForwardRef as ReactComponent };